import { menuDivider, menuItem } from 'base/ui/menu_model';
import { ProjectEditingActions } from '../editing_actions/project';
import {
  HomepageSpaceEditingActions,
  SpaceEditingActions,
} from '../editing_actions/space';
import { pageAskAiMenu } from '../selection_actions';

export function spaceEditMenu(
  projectEditing: ProjectEditingActions,
  actions: SpaceEditingActions | HomepageSpaceEditingActions,
) {
  return [
    ...pageAskAiMenu(projectEditing),
    menuItem({ label: 'Duplicate', onClick: actions.duplicate }),
    menuItem({ label: 'Delete', onClick: actions.deleteWithConfirm }),
    menuDivider(),
    menuItem({
      label: 'Move to top',
      onClick: actions.moveToTop,
      disabled: !actions.moveToTop,
    }),
    menuItem({
      label: 'Move up',
      onClick: actions.moveUp,
      disabled: !actions.moveUp,
    }),
    menuItem({
      label: 'Move down',
      onClick: actions.moveDown,
      disabled: !actions.moveDown,
    }),
  ];
}
